export default "__VITE_ASSET__b52e422e__"